import { MULTI_SESSION_LIMIT_ACTION_TYPE } from "./multi-session-limit.action";

export const MULTI_SESSION_LIMIT_MESSAGE_CONTEXT = {
	get: MULTI_SESSION_LIMIT_ACTION_TYPE.get,
	update: MULTI_SESSION_LIMIT_ACTION_TYPE.update,
	remove: MULTI_SESSION_LIMIT_ACTION_TYPE.remove,
};

export const MULTI_SESSION_LIMIT_MESSAGE_CODES = {
	updateSuccess: "M_MULTI_SESSION_LIMIT_UPDATE_SUCCESS",
	removeSuccess: "M_MULTI_SESSION_LIMIT_REMOVE_SUCCESS",
	error: "E_MULTI_SESSION_LIMIT",
};
